import { render, staticRenderFns } from "./assignStrata.vue?vue&type=template&id=6596f54c&"
import script from "./assignStrata.vue?vue&type=script&lang=js&"
export * from "./assignStrata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports